// Pod color slots, shared by Calendar.js and Notes.js. Values are CSS variables (App.css :root,
// --pod-N-bg/text/border) so the theme sets the actual colors. Use them only in style
// values (background, color, border…), never in string math like appending alpha hex.
export const POD_COLORS = Array.from({ length: 8 }, (_, i) => ({
  bg: `var(--pod-${i + 1}-bg)`,
  text: `var(--pod-${i + 1}-text)`,
  border: `var(--pod-${i + 1}-border)`,
}));
export const POD_COLOR_NAMES = ["Pink", "Mint", "Lavender", "Butter", "Sky", "Peach", "Sage", "Orchid"];

// Colors are per person: each user's pods get different colors in order (oldest first), and anyone can
// pick another color for a pod on its page. Both are saved in userSettings/{uid}.podColors as
// { podId: slot 0–7 }, so colors never reshuffle when pods come and go. Calendar.js keeps this current.
let slots = {};

// Works out this user's color for every pod: their saved slot, else the first slot none of their pods
// use yet. Returns the slots it had to choose, for the caller to save.
export function assignPodColors(pods, saved = {}) {
  const next = {};
  const used = new Set();
  pods.forEach((p) => {
    const s = saved[p.id];
    if (Number.isInteger(s) && s >= 0 && s < POD_COLORS.length) { next[p.id] = s; used.add(s); }
  });
  const fresh = {};
  let wrap = 0;
  pods
    .filter((p) => next[p.id] === undefined)
    .sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0) || (a.name || "").localeCompare(b.name || ""))
    .forEach((p) => {
      let s = POD_COLORS.findIndex((_, i) => !used.has(i));
      if (s === -1) s = wrap++ % POD_COLORS.length; // more than 8 pods: colors repeat
      next[p.id] = s; used.add(s); fresh[p.id] = s;
    });
  slots = next;
  return fresh;
}

export const getPodSlot = (podId) => slots[podId];

// A pod this user isn't in (e.g. a pending invitation) falls back to a stable hash of its id.
export function getPodColor(podId) {
  if (!podId) return POD_COLORS[0];
  if (slots[podId] !== undefined) return POD_COLORS[slots[podId]];
  let hash = 0;
  for (let i = 0; i < podId.length; i++) {
    hash = (hash * 31 + podId.charCodeAt(i)) | 0;
  }
  return POD_COLORS[Math.abs(hash) % POD_COLORS.length];
}
